class NotificationsCache {
  constructor() {
    this.cache = new Map();
    this.lastCheck = null;
    this.checkInterval = 5 * 60 * 1000; // 5 minutes
    this.readManager = new NotificationReadManager();
  }

  // Only check notifications every 5 minutes, not on every drag/drop
  shouldCheckNotifications() {
    const now = Date.now();
    if (!this.lastCheck || (now - this.lastCheck) > this.checkInterval) {
      this.lastCheck = now;
      return true;
    }
    return false;
  }

  // Cache notification results to avoid repeated processing
  getCachedNotifications() {
    return this.cache.get('notifications') || [];
  }

  setCachedNotifications(notifications) {
    this.cache.set('notifications', notifications);
  }

  // Get read status manager
  getReadManager() {
    return this.readManager;
  }

  // Clear cache when needed
  clearCache() {
    this.cache.clear();
    this.lastCheck = null;
  }
}

class NotificationReadManager {
  constructor() {
    this.readNotifications = new Set(
      JSON.parse(localStorage.getItem('readNotifications') || '[]')
    );
  }

  markAsRead(notificationId) {
    this.readNotifications.add(notificationId);
    localStorage.setItem('readNotifications', 
      JSON.stringify([...this.readNotifications])
    );
  }

  isRead(notificationId) {
    return this.readNotifications.has(notificationId);
  }

  // Clean up old read notifications (keep last 100)
  cleanup() {
    const notifications = [...this.readNotifications];
    if (notifications.length > 100) {
      this.readNotifications = new Set(notifications.slice(-100));
      localStorage.setItem('readNotifications', 
        JSON.stringify([...this.readNotifications])
      );
    }
  }

  // Get unread count
  getUnreadCount(notifications) {
    return notifications.filter(n => !this.isRead(n.id)).length;
  }
}

export { NotificationsCache, NotificationReadManager }; 